import { useContext } from 'react';
import { ScheduleContextObject } from '../context/ScheduleContextObject';
import { ScheduleContextType } from '../types';

export const useSchedule = (): ScheduleContextType => {
  const context = useContext(ScheduleContextObject);
  if (context === undefined) {
    throw new Error('useSchedule must be used within a ScheduleDataProvider');
  }
  return context;
};